import { HTTP } from '../http'

export const MEDIASTORAGE_API = {
  getFilesByParameters: async (url, data, sessionId) => {
    return HTTP.post(
      url + 'filter',
      data,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  getFilesDataByParameters: async (url, data, sessionId) => {
    return HTTP.post(
      url + 'filter/metadata',
      data,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  getZipLinkByParameters: async (url, data, sessionId) => {
    return HTTP.post(
      url + 'filter/zip',
      data,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  getFileById: async (url, id, sessionId) => {
    return HTTP.get(
      url + 'resource/' + id,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  updateFileData: async (url, id, data, sessionId) => {
    return HTTP.post(
      url + 'resource/' + id + '/metadata',
      data,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  getRegisteredTypes: async (url, sessionId) => {
    return HTTP.get(
      url + 'resource/types',
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  putFile: async (url, data, sessionId, replace = false) => {
    return HTTP.post(
      url + 'resource?replace=' + replace,
      data,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  deleteFile: async (url, id, sessionId) => {
    return HTTP.delete(
      url + 'resource/' + id,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  replaceBinaryData: async (url, id, data, sessionId) => {
    return HTTP.put(
      url + 'resource/' + id + '/data',
      data,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  registerFileType: async (url, data, sessionId) => {
    return HTTP.post(
      url + 'resource/types',
      data,
      { headers: { 'X-Session-ID': sessionId } }
    )
  },
  createProfileForAgent: async (url, data, sessionId) => HTTP.post(
    url + 'resource',
    data,
    { headers: { 'X-Session-ID': sessionId } }
  )
}
